module.exports = __webpack_public_path__ + "static/media/DemoReel2023_WebsiteHero.e4f45260.mp4";